import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../../base.ui';
import { ParentEvents } from '../../../../utils/parent-events.service';

@Component({
    selector: 'thr-view-account-iban-table',
    templateUrl: './view-account-iban-table.component.html',
    styleUrls: ['./view-account-iban-table.component.scss'],
})
export class ViewAccountIbanTableComponent extends BaseUI implements AfterViewInit, OnDestroy {
    @Input()
    iban: string;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
